// extracted by mini-css-extract-plugin
module.exports = {"v-application":"Tabs_v-application_22ZIk","text-h1":"Tabs_text-h1_2IzF-","text-h2":"Tabs_text-h2_3QhhO","tabs":"Tabs_tabs_2Zr2z","activeTab":"Tabs_activeTab_2Fg4W"};